import React from 'react';
import classNames from 'classnames';
import { Listing } from 'models/Listing';
import utils, { checkIsTierPremium, isNewListing } from 'utils';
import { Link } from 'react-router-dom';
import EoiDate from 'components/EoiDate';
import ListingLocation from 'components/ListingLocation';
import StatusBadge from 'router/subrouters/Dash/subrouters/Business/pages/Businesses/components/StatusBadge';
import ListingCardThumbnail from 'components/ListingCardThumbnail';
import ListingActions from 'router/subrouters/Dash/subrouters/Business/components/ListingActions';

import './DistressedListingCard.styles.scss';
import './DistressedListingCard.styles.responsive.scss';

type DistressedListingCardProps = {
  className?: string;
  listing: Listing;
  onWatchlisted: (isWatchlisted: boolean) => void;
};

const DistressedListingCard: React.FC<DistressedListingCardProps> = (props) => {
  const { className, listing, onWatchlisted } = props;

  const {
    listingTitle,
    industry,
    gallery,
    locationPostcode,
    createdAt,
    slugName,
    businessDescription,
    type,
    listingContact,
    seekingExpressionOfInterestDate,
    tier,
  } = listing;

  const firmLogo = listingContact?.firmLogo?.url;

  const isListingPremium = checkIsTierPremium(tier);

  const classes = classNames('urgent-campaigns-listing-card', className);

  const redirectionListingLink = utils.composeBusinessUrl(
    industry,
    slugName,
    type,
  );

  return (
    <div className={classes}>
      <div className="urgent-campaigns-listing-card__left">
        <div className="urgent-campaigns-listing-card__left__heading">
          <StatusBadge isNew={isNewListing(createdAt)} />
          <Link
            className="urgent-campaigns-listing-card__left__heading__title"
            to={redirectionListingLink}
          >
            {listingTitle}
          </Link>
          <ListingLocation
            isUrgentListing
            to={redirectionListingLink}
            industry={industry}
            locationPostcode={locationPostcode}
          />
        </div>
        <EoiDate
          seekingExpressionOfInterestDate={seekingExpressionOfInterestDate}
        />
        <Link
          className="urgent-campaigns-listing-card__left__description"
          to={redirectionListingLink}
        >
          {businessDescription}
        </Link>

        <ListingActions listing={listing} onWatchlisted={onWatchlisted} />
      </div>

      <ListingCardThumbnail
        to={redirectionListingLink}
        gallery={gallery}
        firmLogo={firmLogo}
        isPremium={isListingPremium}
        shouldLazyLoad={false}
      />
    </div>
  );
};

export default DistressedListingCard;
